<template>
  <div class="sidebar-container flex w-[216px] flex-col justify-between">
    <nav>
      <ul>
        <SidebarMenu
          v-for="menu in sidebar"
          :key="menu.value"
          v-bind="{
            ...menu,
            depth: 1,
          }"
        />
      </ul>
    </nav>
    <div class="flex flex-wrap pb-4 pl-4">
      <BcButton
        v-for="social in socialList"
        :key="social.link"
        :icon="social.icon"
        background-color="none"
        @click="openLink(social.link)"
        color="#00ADB2"
        class="p-2"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { BcButton } from 'xangle-ui'

import { useGeneralSocialInfo } from '~/api/service/general.service'
import { useProjectTokenList } from '~/api/service/profile.service'
import { APTOS_SIDEBAR } from '~/constants/sidebar.constant'

const { data: tokenList } = useProjectTokenList()
const { data: socialList } = useGeneralSocialInfo([ 'ALL' ])

const openLink = (url: string) => {
  window.open(url, '_blank')
}

// temp
const sidebar = computed(() => {
  return APTOS_SIDEBAR.map((sidebarMenu) => {
    if (sidebarMenu.value === 'profile') {
      return {
        ...sidebarMenu,
        children: sidebarMenu.children?.map((sidebarSubMenu) => {
          if (sidebarSubMenu.value === 'token') {
            if (tokenList.value?.length === 1) {
              return {
                ...sidebarSubMenu,
                value: `${sidebarSubMenu.value}/${tokenList.value[0].value}`
              }
            } else {
              return {
                ...sidebarSubMenu,
                children: tokenList.value?.map(token => {
                  return {
                    label: token.label,
                    value: token.value,
                  }
                }),
              }
            }
          }
          return sidebarSubMenu
        })
      }
    }
    return sidebarMenu
  })
})
</script>


<style scoped lang="scss">
.sidebar-container {
  height: calc(100% - 72px);
}

:deep(.bc-button-container) {
  .svg {
    fill: $primary-color !important;
  }

  &:hover {
    @apply bg-primary/10 rounded-none;
  }

  :deep(.button-wrapper) {
    :deep(.svg) {
      fill: $primary-color !important;
    }
  }
}
</style>